// Phase 6 Step 1 — screen-as-data: the versioned filter-tree schema (pure, no DOM, no globals).
//
// A "screen" is a serializable predicate tree. A node is either a GROUP (AND/OR/NOT over children)
// or a LEAF (one registered filter clause + its captured params). Step 1 only ever emits a flat AND
// of leaves — exactly today's imperative screen shape — but the schema supports AND/OR/NOT so the URL
// codec (Step 2) and future compound screens have room without a version bump.
//
// Leaf `p` (params) is captured by value (not a live reference), so a tree round-trips through JSON
// losslessly. Each leaf's `id` names a descriptor in registry.js, which owns the actual predicate.

export const SCHEMA_VERSION = 1;

/** A group node combining children by a boolean operator. */
export function group(op, kids) {
    return { t: 'g', op, kids: kids || [] };
}

/** A leaf node: one registered clause `id` plus its captured params `p`. */
export function leaf(id, p) {
    return { t: 'f', id, p };
}

/** Wrap a root node into a versioned screen envelope. */
export function screen(root) {
    return { v: SCHEMA_VERSION, root };
}

export const OPS = { AND: 'AND', OR: 'OR', NOT: 'NOT' };
